// 阅读次数统计工具

const STORAGE_KEY = "blog_view_counts";
const VIEW_RECORD_KEY = "blog_viewed_articles";

/**
 * 获取文章的阅读次数
 * @param {string} articleId - 文章ID
 * @returns {number} 阅读次数
 */
export function getViewCount(articleId) {
  try {
    const counts = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return counts[articleId] || 0;
  } catch (error) {
    console.error("Error reading view count:", error);
    return 0;
  }
}

/**
 * 增加文章的阅读次数
 * @param {string} articleId - 文章ID
 * @returns {number} 更新后的阅读次数
 */
export function incrementViewCount(articleId) {
  try {
    // 获取当前所有阅读次数
    const counts = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

    // 增加当前文章的阅读次数
    counts[articleId] = (counts[articleId] || 0) + 1;

    // 保存到 localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));

    return counts[articleId];
  } catch (error) {
    console.error("Error incrementing view count:", error);
    return 0;
  }
}

/**
 * 检查文章在当前会话中是否已被查看
 * @param {string} articleId - 文章ID
 * @returns {boolean} 是否已查看
 */
export function hasViewedInSession(articleId) {
  try {
    const viewed = JSON.parse(sessionStorage.getItem(VIEW_RECORD_KEY) || "[]");
    return viewed.includes(articleId);
  } catch (error) {
    console.error("Error checking view record:", error);
    return false;
  }
}

/**
 * 标记文章在当前会话中已被查看
 * @param {string} articleId - 文章ID
 */
export function markAsViewedInSession(articleId) {
  try {
    const viewed = JSON.parse(sessionStorage.getItem(VIEW_RECORD_KEY) || "[]");
    if (!viewed.includes(articleId)) {
      viewed.push(articleId);
      sessionStorage.setItem(VIEW_RECORD_KEY, JSON.stringify(viewed));
    }
  } catch (error) {
    console.error("Error marking as viewed:", error);
  }
}

/**
 * 格式化阅读次数显示
 * @param {number} count - 阅读次数
 * @returns {string} 格式化后的字符串
 */
export function formatViewCount(count) {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  } else if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return count.toString();
}
